import * as actionTypes from '../actions/actionTypes';
import {
    updateObject
} from '../../shared/utility';

const initialState = {
    staticIp: {},
    staticIpSuccess: false,
    staticIpFail: false,
    staticIpLoading: false,
    staticIpFailureMesssage: '',
    staticIpDeleteSuccess: false,
    staticIpDeleteFail: false,
    deviceDeleteSuccess: false,
    deviceDeleteFail: false,
    upstreamError: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_STATIC_IP_LOADING:
            return updateObject(state, {
                staticIp: {},
                staticIpLoading: true
            });
        case actionTypes.DELETE_STATIC_IP_INFO:
            return updateObject(state, {
                staticIpDeleteFail: false,
                staticIpDeleteSuccess: false
            });
        case actionTypes.DELETE_STATIC_IP_INFO_SUCCESS:
            return updateObject(state, {
                staticIp: {},
                staticIpDeleteSuccess: true,
                staticIpDeleteFail: false,
            });
            case actionTypes.DELETE_STATIC_IP_INFO_FAILED:
                return updateObject(state, {
                    staticIpDeleteFail: true,
                    staticIpDeleteSuccess: false
                });
        case actionTypes.GET_STATIC_IP_SUCCESS:
            return updateObject(state, {
                staticIp: action.payload?.message,
                staticIpLoading: false
            });
        case actionTypes.GET_STATIC_IP_FAIL:
            return updateObject(state, {
                staticIp: {},
                staticIpFail: true,
                staticIpLoading: false
            });
        case actionTypes.SET_STATIC_IP_FAIL_MESSAGE:
            return updateObject(state, {
                staticIpFailureMesssage:action.info,
            });
        case actionTypes.RESET_STATIC_IP_ERROR_SUCCESS:
            return updateObject(state , {
                staticIpSuccess: false,
                staticIpFail: false,
                staticIpFailureMesssage: '',
                staticIpDeleteSuccess: false,
                staticIpDeleteFail: false,
                deviceDeleteSuccess: false,
                deviceDeleteFail: false,
                staticIpDeleteFailureMesssage: false
                });
        case actionTypes.SET_STATIC_IP:
            return updateObject(state, {
                staticIpLoading: true,
                staticIpSuccess: false,
                staticIpFail: false
            });
        case actionTypes.SET_STATIC_IP_SUCCESS:
            return updateObject(state, {
                staticIpSuccess: true,
                staticIpFail: false,
                staticIp: action.payload?.message,
            });
        case actionTypes.SET_STATIC_IP_LOADING:
            return updateObject(state, {
                staticIpLoading: true,
                staticIpSuccess: false,
                staticIpFail: false
            });
        case actionTypes.SET_STATIC_IP_FAIL:
            return updateObject(state,{
                staticIpSuccess: false,
                staticIpFail: true
            });

     
        case actionTypes.SET_UPSTREAM_ERROR:
            return updateObject(state, { upstreamError: true, staticIpLoading: false });
        case actionTypes.RESET_UPSTREAM_ERROR:
            return updateObject(state, { upstreamError: false });
        default: return state;
    }
};
export default reducer;
